export function uuIdGenerator() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  );
}

export function findPathByUuId(obj, uuid, path = '') {
  if (obj == null) return '';
  if (obj.uuid === uuid) {
    return path;
  }
  for (let property in obj) {
    if (typeof obj[property] === 'object') {
      let found = findPathByUuId(obj[property], uuid, path + property + '.');
      if (found) {
        return found;
      }
    }
  }
  return '';
}
